import { databaseUpdate } from "./database";
import { endOfToday } from "../time";
import { join } from "../channel";

export const MY_GAMES_LOADED = "MY_GAMES_LOADED";
export const MY_GAMES_LOADING = "MY_GAMES_LOADING";
export const MY_GAMES_COUNTS = "MY_GAMES_COUNTS";

export function loadFutureGames(currentUserId, page, pageSize) {
  return loadGames("future_tournaments", currentUserId, page, pageSize);
}

function loadGames(messageType, currentUserId, page, pageSize) {
  return (dispatch) => {
    dispatch({ type: MY_GAMES_LOADING });
    var sessionChannel = join("session:" + currentUserId);
    sessionChannel.push(messageType, { "end_of_today": endOfToday().toISOString(), page, "page_size": pageSize })
      .receive("ok", (tables) => {
        dispatch(databaseUpdate(tables));
        dispatch({
          type: MY_GAMES_LOADED,
          ids: tables.tournaments.map((t) => t.id)
        });
      });
  };
}

export function loadCounts(currentUserId) {
  return (dispatch) => {
    var sessionChannel = join("session:" + currentUserId);
    sessionChannel.push("my_games_counts", { "end_of_today": endOfToday().toISOString() })
      .receive("ok", (counts) => {
        dispatch({
          type: MY_GAMES_COUNTS,
          counts: counts
        });
      });
  };
}
export function loadCompletedGames(currentUserId, page, pageSize) {
  return loadGames("past_tournaments", currentUserId, page, pageSize);
}

export function loadTrophyCase(currentUserId, page, pageSize) {
  return loadGames("trophy_case", currentUserId, page, pageSize);
}
